import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isEngNumber(str, responseText) {
    const regVal = regexList.engNumber.pattern;
    return regexTest(str, regVal, responseText) || regexList.engNumber.response;
}